import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import dayjs from 'dayjs';
import emitter from '@/eventbus/index';
import { useRouter } from 'vue-router';
import useTrend from './hooks/useTrend';
import useTotalData from './hooks/useTotalData';
import { useEmptyStringFormat } from '@/hooks/fn';
import LastHourFeed from './cpns/LastHourFeed.vue';
import useElectricPrice from './hooks/useElectricPrice';
import { computed, defineComponent, onMounted, ref } from 'vue';
import { PieEchart, BarEchartMul } from '@/components/page-echarts';
export default defineComponent({
  name: 'ReportAggregateDaily',
  components: {
    PieEchart: PieEchart,
    BarEchartMul: BarEchartMul,
    LastHourFeed: LastHourFeed
  },
  setup: function setup() {
    var emptyStringFormat = useEmptyStringFormat();
    // 选择日期
    var confrimDate = function confrimDate(val) {
      params.value.date = val;
      //获取能源统计
      getElectricTotalAsync();
      getElectricMeterTrendAsync();
      getElectricPriceRuleAsync();
      getElectricBasicsPriceAsync();
      if (params.value.type === 3) {
        getElectricMeterTrendYearAsync();
      }
    };
    var confirmType = function confirmType(val) {
      params.value.type = val;
      if (val === 4) {
        params.value.date = dayjs().format('YYYY/MM/DD') + ',' + dayjs().format('YYYY/MM/DD');
      } else {
        params.value.date = dayjs().format('YYYY/MM/DD');
      }
      //获取能源统计
      getElectricTotalAsync();
      getElectricMeterTrendAsync();
      getElectricPriceRuleAsync();
      getElectricBasicsPriceAsync();
      if (params.value.type === 3) {
        getElectricMeterTrendYearAsync();
      }
    };
    var params = ref({
      date: dayjs().format('YYYY/MM/DD'),
      type: 0 //时间类型 0日数据 1周数据 2月数据
    });
    //获取能源统计
    var _useTotalData = useTotalData(params),
      _useTotalData2 = _slicedToArray(_useTotalData, 3),
      totalData = _useTotalData2[0],
      summaryData = _useTotalData2[1],
      getElectricTotalAsync = _useTotalData2[2];
    //获取趋势
    var _useTrend = useTrend(params),
      _useTrend2 = _slicedToArray(_useTrend, 4),
      trendData = _useTrend2[0],
      trendYearData = _useTrend2[1],
      getElectricMeterTrendAsync = _useTrend2[2],
      getElectricMeterTrendYearAsync = _useTrend2[3];
    var title = computed(function () {
      var text = '';
      if (params.value.type === 0) {
        text = '各时段';
      } else if (params.value.type === 1) {
        text = '本周';
      } else if (params.value.type === 2) {
        text = '本月各日';
      } else if (params.value.type === 3) {
        text = '本年各月';
      }
      return text;
    });
    //电量电费
    var tabs = ref(['耗电量', '电费']);
    var curTab = ref('耗电量');
    var tabClick = function tabClick(val) {
      curTab.value = val;
    };
    var categoryGoodsCount = computed(function () {
      var list = [];
      if (curTab.value === '耗电量') {
        list = totalData.value.areaElectricMeterList.map(function (item) {
          return {
            name: item.area_name,
            value: item.electric_value
          };
        }).filter(function (item) {
          return item.value;
        });
      }
      if (curTab.value === '电费') {
        list = totalData.value.areaElectricMeterList.map(function (item) {
          return {
            name: item.area_name,
            value: item.electric_fee
          };
        }).filter(function (item) {
          return item.value;
        });
      }
      return {
        pieData: list,
        customLabel: true,
        labelFormatter: function labelFormatter(params) {
          var res = '';
          if (curTab.value === '耗电量') {
            res = "".concat(params.name, "\n\u8017\u7535\u91CF\uFF1A").concat(params.value, "\u5EA6");
          }
          if (curTab.value === '电费') {
            res = "".concat(params.name, "\n\u7535\u8D39\uFF1A").concat(params.value, "\u5143");
          }
          return res;
        },
        customTooltip: true,
        tooltipFormatter: function tooltipFormatter(params) {
          var res = "\n              <div >\n              ";
          if (curTab.value === '耗电量') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                    <div>\n                      <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                      <div>\n                        <span style=\"font-size: 12px;\">\u8017\u7535\u91CF ").concat(params.value, "\u5EA6</span>\n                      </div>\n                    </div>\n                  </div>\n                ");
          }
          if (curTab.value === '电费') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                    <div>\n                      <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                      <div>\n                        <span style=\"font-size: 12px;\">\u7535\u8D39 ").concat(params.value, "\u5143</span>\n                      </div>\n                    </div>\n                  </div>\n                ");
          }
          res += '</div>';
          return res;
        }
      };
    });
    var _useElectricPrice = useElectricPrice(params),
      _useElectricPrice2 = _slicedToArray(_useElectricPrice, 4),
      priceRule = _useElectricPrice2[0],
      basePrice = _useElectricPrice2[1],
      getElectricPriceRuleAsync = _useElectricPrice2[2],
      getElectricBasicsPriceAsync = _useElectricPrice2[3];
    var router = useRouter();
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            emitter.on('sss', function (data) {
              if (data.seriesType === 'pie') {
                router.push("/energyDetail?date=".concat(params.value.date, "&type=").concat(params.value.type, "&areaName=").concat(data.data.name));
              }
              //console.log(params.value,data.name);
            });
            //获取能源统计
            getElectricTotalAsync();
            getElectricMeterTrendAsync();
            getElectricPriceRuleAsync();
            getElectricBasicsPriceAsync();
            if (params.value.type === 3) {
              getElectricMeterTrendYearAsync();
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return {
      params: params,
      confirmType: confirmType,
      confrimDate: confrimDate,
      emptyStringFormat: emptyStringFormat,
      summaryData: summaryData,
      tabs: tabs,
      curTab: curTab,
      tabClick: tabClick,
      categoryGoodsCount: categoryGoodsCount,
      trendData: trendData,
      trendYearData: trendYearData,
      title: title,
      priceRule: priceRule,
      basePrice: basePrice
    };
  }
});